import { MuiTheme } from "theme";
import makeStyles from "@material-ui/core/styles/makeStyles";
import Breakpoints from "common/breakpoints";

export default makeStyles((theme: MuiTheme) => {
  const { primary, warning } = theme.palette;

  const desktopGridTemplateColumns = "280px 60px 60px";
  const mobileGridTemplateColumns = "136px 60px 60px";

  return {
    muiDialogTitle: {
      padding: "0 4px 0 20px"
    },
    paper: {
      width: 428,
      height: 345,
      borderRadius: 3,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        width: 296,
        height: 333
      }
    },
    dialogHeader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      height: 56,
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular"
    },
    horseName: {
      fontSize: 14,
      textTransform: "uppercase",
      fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
      marginBottom: 10
    },
    muiDialogContent: {
      padding: 0,
      overflowY: "hidden"
    },
    italicCell: {
      fontStyle: "italic"
    },
    closeIcon: {
      color: primary.main,
      "& .MuiSvgIcon-root": {
        fontSize: "28px"
      }
    },
    tableHeader: {
      display: "grid",
      gridTemplateColumns: desktopGridTemplateColumns,
      padding: "0 0 0 20px",
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        gridTemplateColumns: mobileGridTemplateColumns
      }
    },
    tableContent: {
      maxHeight: 240,
      overflowY: "auto",
      paddingBottom: 13,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        paddingBottom: 24
      }
    },
    tableRow: {
      borderTop: "1px solid #eee",
      color: primary.dark,
      padding: "0 16px 0 20px",
      "&:nth-child(odd)": {
        backgroundColor: "#fbfbfb"
      },
      "&:last-child": {
        borderBottom: "1px solid #eee"
      }
    },
    tableRowContent: {
      display: "grid",
      gridTemplateColumns: desktopGridTemplateColumns,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        gridTemplateColumns: mobileGridTemplateColumns
      }
    },
    cell: {
      fontSize: 12,
      display: "flex",
      alignItems: "flex-start",
      justifyContent: "center",
      minHeight: 70,
      flexWrap: "wrap",
      flexDirection: "column"
    },
    headCell: {
      color: primary.main,
      minHeight: 30,
      [theme.breakpoints.down(Breakpoints.XS_420)]: {
        fontSize: 10
      }
    },
    centerCell: {
      alignItems: "center"
    },
    shortDescription: {
      textTransform: "capitalize",
      minHeight: 40,
      display: "flex",
      alignItems: "center"
    },
    detailed: {
      fontSize: 10,
      color: primary.dark,
      paddingBottom: 9,
      display: "flex",
      flexWrap: "wrap",
      minHeight: 30,
      alignItems: "center"
    },
    alert: {
      color: warning.dark
    }
  };
});
